import React, { useEffect, useState } from 'react';
import { IonTextarea, IonButton, useIonToast } from '@ionic/react';
import { getComentario, IComentarioFiscaliacion, IPostComentarioFiscalizacion, postComentarioFiscalizacion } from 'src/services/Fiscalizacion/Fiscalizacion';
import { Divider, Typography } from '@material-ui/core';
import { useHistory, useParams } from 'react-router';

interface Params {
    fis_id: string;
    nombre: string;
    codigo: string;
    objetivo: string;
    ps_id: string;
    cod_id: string;
}

const ComentarioFiscalizacion: React.FC = () => {
    const history = useHistory();
    const { fis_id, cod_id } = useParams<Params>();
    const [comentario, setComentario] = useState({ comentario: '' });
    const [comentariosExistentes, setComentariosExistentes] = useState<IComentarioFiscaliacion[]>([]);
    const [errorMessagePresent, setErrorMessagePresent] = useState<string | undefined | null>(undefined);
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const [present] = useIonToast();

    useEffect(() => {
        const obtenerOpinion = async () => {
            try {
                // Si venimos a la ruta de opinión, forzamos el cod_id a "1" (Opinion Cliente) para evitar mezclar con otros tipos.
                const codForFetch = window.location.pathname.includes('fiscalizaropinion') ? '1' : cod_id;
                const resultado = await getComentario(parseInt(fis_id), codForFetch);
                console.log(resultado);
                if (resultado?.error) {
                    setErrorMessagePresent(resultado.error);
                    console.error('Error al obtener la opinion:', resultado.error);
                    // Permitimos crear comentario aunque falle la lectura y evitamos crash
                    setComentariosExistentes([]);
                    setButtonDisabled(false);
                    return;
                }

                const datos = resultado?.datos;
                if (!datos) {
                    setComentariosExistentes([]);
                    setButtonDisabled(false);
                    return;
                }

                setComentariosExistentes([datos]);
                setErrorMessagePresent(null); // Limpiar mensaje de error en caso de éxito
                if (!datos.comentario) {
                    setButtonDisabled(false); // Habilitar el botón si no hay comentario
                } else {
                    setButtonDisabled(true); // Deshabilitar el botón si ya existe un comentario
                }
            } catch (error: any) {
                setErrorMessagePresent(error.info);
                console.error('ERROR:', error);
                setComentariosExistentes([]);
                setButtonDisabled(false); // Permitimos crear comentario si la consulta falla
            }
        };

        obtenerOpinion();
    }, [cod_id, fis_id]);

    useEffect(() => {
        if (errorMessagePresent) {
            present(errorMessagePresent, 6000);
            setErrorMessagePresent(undefined);
        }
    }, [errorMessagePresent, present]);

    const guardarComentario = async () => {
        const comentarioData: IPostComentarioFiscalizacion = {
            fis_id: parseInt(fis_id),
            comentario: comentario.comentario,
            cod_id: cod_id,
        };
        
        const resultado = await postComentarioFiscalizacion(comentarioData);
        if (!resultado || resultado.exito === false) {
            present(resultado?.info || 'No se pudo guardar el comentario', 6000);
            return;
        }

        if (resultado.info) {
            present(resultado.info, 6000);
        } else {
            present('Comentario guardado con exito', 6000);
        }

        setComentario({ comentario: '' });
        history.goBack();
    };

    return (
        <div className="fisContainer">
            <div className="fisCard">
                <div className="fisCard_title--area">
                    <img src="assets/icon/fisc-COD5.svg" alt="Opinion del Cliente" />
                    <h1>comentario adicional</h1>
                </div>
                <IonTextarea
                    placeholder="Ingrese su comentario aqui"
                    value={comentario.comentario || ''}
                    onIonChange={(e) => setComentario({ ...comentario, comentario: e.detail.value || '' })}
                ></IonTextarea>
                <Divider style={{ margin: '20px 0' }} />
                <IonButton onClick={guardarComentario} disabled={buttonDisabled}>Guardar comentario</IonButton>
            </div>
            {comentariosExistentes.filter(Boolean).map((item, index) => (
                <div className="comentarios" key={index}>
                    <div className="fisCard">
                        <div className="d-flex justify-content-between">
                            <div>
                                <h4>Comentario:</h4>
                                <Typography>{item.comentario}</Typography>
                            </div>
                        </div>
                        <hr />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ComentarioFiscalizacion;
